export default {
    'delete-message': 'Are you sure you want to delete this skill?',
    'add-skill': 'Add skill',
    headers: {
        skill: 'Skill'
    }
}